export class DocsLink {
  public static sdkIntegrationDocLinks = {
    hanselPush: {
      android: 'https://docs.hansel.io/v2.0/docs/hansel-push-android',
      ios: 'https://docs.hansel.io/v2.0/docs/hansel-push-ios'
    },
    sdkIntegration: {
      android: 'https://docs.netcoresmartech.com/docs/android-sdk-product-experience',
      ios: 'https://docs.netcoresmartech.com/docs/ios-product-experience',
      web: 'https://docs.netcoresmartech.com/docs/web-sdk-product-experience',
      java_be: 'https://docs.hansel.io/v2.0/docs/back-end-reference-docs',
      be: 'https://docs.hansel.io/v2.0/docs/back-end-reference-docs'
    },
    userOnboarding: {
      android: 'https://docs.hansel.io/v3.0/docs/android-reference-docs',
      ios: 'https://docs.hansel.io/v3.0/docs/ios-reference-docs',
      question_icon: 'https://docs.hansel.io/v3.0/docs',
      billing_manage: 'https://docs.hansel.io/v3.0/docs/manage-your-plan',
      interaction_map_activate: 'https://docs.hansel.io/v3.0/docs/creating-apps-on-hansel',
      sandbox_info: 'https://docs.hansel.io/v3.0/docs/production-and-sandbox-apps'
    },
    pro: {
      interaction_map_activate: 'https://docs.hansel.io/v2.0/docs/creating-apps-on-hansel',
      sandbox_info: 'https://docs.hansel.io/docs/production-and-sandbox-apps'
    },
    analytics: {
      android: 'https://docs.netcoresmartech.com/docs/android-sdk-product-experience#step-5-using-existing-analytics-events-for-triggers-and-goals',
      ios: 'https://docs.netcoresmartech.com/docs/ios-product-experience#step-6-configuring-analytics',
      web: 'https://docs.netcoresmartech.com/docs/web-sdk-product-experience#step-3-using-existing-analytics-events-for-triggers-and-goals',
    },
    buttonAction: {
      android: 'https://docs.netcoresmartech.com/docs/android-defining-actions',
      ios: 'https://docs.netcoresmartech.com/docs/ios-defining-actions',
      web: 'https://docs.netcoresmartech.com/docs/web-defining-actions'
    },
    eventsLinks: {
      android: 'https://docs.netcoresmartech.com/docs/android-sdk-product-experience#step-5-using-existing-analytics-events-for-triggers-and-goals',
      ios: 'https://docs.netcoresmartech.com/docs/ios-product-experience#step-6-configuring-analytics',
      web: 'https://docs.netcoresmartech.com/docs/web-sdk-product-experience#step-3-using-existing-analytics-events-for-triggers-and-goals'
    },
    attributeLink: {
      android: 'https://docs.netcoresmartech.com/docs/android-sdk-product-experience#step-6-audience-targeting-based-on-user-profile-data',
      ios: 'https://docs.netcoresmartech.com/docs/ios-product-experience#step-7-audience-targeting-based-on-user-profile-data',
      web: 'https://docs.netcoresmartech.com/docs/web-sdk-product-experience#step-4-audience-targeting-based-on-user-profile-data'
    },
    test_devices_eventLinks: {
      android: 'https://docs.netcoresmartech.com/docs/android-sdk-product-experience-setting-up-test-devices',
      ios: 'https://docs.netcoresmartech.com/docs/nudges-setting-up-test-devices',
      web: 'https://docs.netcoresmartech.com/docs/web-sdk-setting-up-test-devices'
    },
    analyticsEventListenerLinks: {
      android: "https://docs.netcoresmartech.com/docs/android-product-experience-advanced",
      ios: "https://docs.netcoresmartech.com/docs/ios-product-experience-advanced",
      web: "https://docs.netcoresmartech.com/docs/web-product-experience-advanced"
    },
    testDevice: {
      android: 'https://cedocs.netcorecloud.com/docs/android-sdk-product-experience-setting-up-test-devices',
      ios: 'https://cedocs.netcorecloud.com/docs/nudges-setting-up-test-devices',
      web: 'https://cedocs.netcorecloud.com/docs/web-sdk-setting-up-test-devices'
    }
  };
}
